<template>
<div class="chapter">
<div class="inner_page">
<div class="publishingproduct_cover_image"><img alt="How to Read Tarot" src="images/188I103132_-423850_100.jpg" style="height:100%;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// U103132.vue?7fd751c4